import React from 'react';
import './Result.scss';
import ItemList from '../ItemList/ItemList';

export default ({ foundItems, items }) => {

  return (
    <div className="result">
      <h2 className="result__found-items">found {foundItems} mars rover photos.</h2>
      <ItemList 
        items={items}
      />
    </div>
  )
}